module.exports = __webpack_public_path__ + "img/icon__edication.6f4fa51f.svg";